import React from 'react';
import PropTypes from 'prop-types';
import { WIDGET_GRID_COPY } from '../../constants';

const WidgetEmptyState = ({ message = WIDGET_GRID_COPY.states.noData }) => {
  return (
    <div className="flex flex-col items-center justify-center gap-3 h-full p-6 text-center bg-surface-muted/80 rounded-lg">
      <p className="m-0 text-base text-content-muted leading-snug">{message}</p>
    </div>
  );
};

WidgetEmptyState.propTypes = {
  message: PropTypes.string,
};


export default WidgetEmptyState;
